'use strict'

import Blockly from 'blockly'

const getWorkspaceXml = () => {
  const workspace = Blockly.getMainWorkspace()
  const dom = Blockly.Xml.workspaceToDom(workspace)
  return Blockly.Xml.domToText(dom)
}

const setWorkspaceXml = (xml) => {
  if (xml) {
    const workspace = Blockly.getMainWorkspace()
    const dom = Blockly.Xml.textToDom(xml)
    workspace.clear()
    Blockly.Xml.domToWorkspace(dom, workspace)
    // move workspace scroll : center
    workspace.scrollCenter()
  }
}

const removeWorkspace = () => {
  const workspace = Blockly.getMainWorkspace()
  workspace.clear()
  workspace.scrollCenter()
}

const getVariableArray = (block) => {
  let ret = []
  _.forEach(block.getChildren(true), (b) => {
    while (b) {
      const v = _.get(b.getVarModels(), '[0].name')
      if (v) ret.push(v)
      const child = getVariableArray(b)
      ret = _.union(ret, child)
      b = b.getNextBlock()
    }
  })
  return ret
}

const getVariables = (block) => {
  let arr = getVariableArray(block)
  if (_.size(arr) > 0) return '  global ' + _.join(_.compact(arr), ', ') + '\n'
  return ''
}

const oneBlockForType = (type) => {
  const workspace = Blockly.getMainWorkspace()
  let existStartOnBoot = false
  _.forEach(workspace.getTopBlocks(), (b) => {
    switch (b.type) {
      case type:
        if (existStartOnBoot) b.dispose(false)
        else existStartOnBoot = true
        break
      default:
        break
    }
  })
}

const removeDisabledBlock = () => {
  const workspace = Blockly.getMainWorkspace()
  _.forEach(workspace.getTopBlocks(), (b) => {
    if (b.disabled) b.dispose(false)
  })
}

const setDisableByDevice = (disableArr, isDeviceChange) => {
  const workspaces = Blockly.Workspace.getAll()
  _.forEach(workspaces, (w) => {
    _.forEach(w.getAllBlocks(), (b) => {
      if (_.includes(disableArr, b.type)) b.setEnabled(false)
      else if (isDeviceChange) b.setEnabled(true)
    })
  })
}

export default {
  getWorkspaceXml,
  setWorkspaceXml,
  removeWorkspace,
  getVariables,
  oneBlockForType,
  removeDisabledBlock,
  setDisableByDevice
}
